import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "src/config/constants/genericConstants";
import { resetStore } from "src/store/actions";
import { fetchNotificationLog } from "./notifiationLog.thunk";
import {
  NotificationItem,
  NotificationLogInitialState
} from "./notification.interface";
import { getExpiryTimeForFormatAlert } from "src/utils/getDates";
import { sortBy } from "lodash";

const initialState: NotificationLogInitialState = {
  notifications: [],
  apiStatus: API_STATUS.IDLE,
  error: null,
  recentNotificationsCountInTile: 0
};

const notificationLog = createSlice({
  name: "notificationLog",
  initialState,
  reducers: {
    updateRecentNotificationsCountInTile: (state, action) => {
      state.recentNotificationsCountInTile = action.payload.count;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, () => {
        return initialState;
      })
      .addCase(fetchNotificationLog.pending, (state) => {
        state.apiStatus = API_STATUS.PENDING;
        state.notifications = [];
      })
      .addCase(fetchNotificationLog.fulfilled, (state, action) => {
        const formattedNotifications = action.payload?.data?.map(
          (alert: NotificationItem) => ({
            ...alert,
            remainingTime: getExpiryTimeForFormatAlert(
              alert.alertCreatedDate,
              alert.sla
            )?.toISOString()
          })
        );

        state.notifications = [
          ...sortBy(formattedNotifications, "remainingTime")
        ];
        state.apiStatus = API_STATUS.IDLE;
      })
      .addCase(fetchNotificationLog.rejected, (state, action) => {
        state.notifications = [];
        state.apiStatus = API_STATUS.ERROR;
        state.error = action.error.message;
      });
  }
});

export const { updateRecentNotificationsCountInTile } = notificationLog.actions;

export default notificationLog.reducer;
